export function displayAyuda() {}

export function displayAyudaMobile() {}
